import React, { useCallback, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import HelperIcon from './Icons/HelperIcon';
import HelpAttachmentLanding from './Landing';
import { useListener } from 'react-bus';
import { motion, AnimatePresence } from 'framer-motion';
import HelpAttachmentContact from './Contact';
import HelpAttachmentSupportForm from './HelpAndSupport';
import { HelpAttachmentProps } from './types';
import HelpAttachmentGuides from './Guides';
import HelpAttachmentGuidesView from './Guides/View';

const HelpAttachment: React.FC<HelpAttachmentProps> = (props) => {
  const [shown, setShown] = useState(false);

  const [currentView, setCurrentViewfn] = useState('landing');
  const [previousViews, setPreviousViews] = useState(['landing']);

  const setCurrentView = useCallback(
    (view: string) => {
      setPreviousViews([...previousViews, currentView]);
      setCurrentViewfn(view);
    },
    [currentView, previousViews]
  );

  useListener(
    'open-help-link',
    useCallback(
      (link) => {
        setShown(true);
        // @ts-ignore
        setCurrentView(link);
      },
      [setCurrentView]
    )
  );

  const goBack = () => {
    setCurrentView(previousViews[previousViews.length - 1]);
    setPreviousViews(
      previousViews.filter(
        (pv) => pv !== previousViews[previousViews.length - 1]
      )
    );
  };

  const animateButton = {
    hidden: {
      opacity: 0,
      scale: 0,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delay: 0.5,
        duration: 0.2,
      },
    },
  };

  const animateContainer = {
    hidden: {
      opacity: 0,
      bottom: -800,
      right: -400,
    },
    visible: {
      opacity: 1,
      bottom: 100,
      right: 24,
      transition: {
        delay: 0,
        opacity: { duration: 0.2 },
        default: { duration: 0.4 },
      },
    },
    exit: {
      opacity: 0,
      bottom: -800,
      right: -400,

      transition: {
        delay: 0,
        opacity: { duration: 0.4 },
        default: { duration: 0.2 },
      },
    },
  };

  return (
    <>
      <AnimatePresence>
        {shown && (
          <motion.div
            key="helper-holder"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={animateContainer}
            className={`fixed bottom-24 right-6 bg-gray-50 shadow-md rounded-lg transition ease-in-out duration-250 text-white overflow-auto hide-scrollbar h-4/6 w-96 opacity-100 z-50`}
          >
            <div className={`${shown ? 'opacity-100' : 'opacity-0'}`}>
              {currentView === 'landing' && (
                <HelpAttachmentLanding
                  {...{ setCurrentView, goBack, appData: props }}
                />
              )}

              {currentView === 'contact' && (
                <HelpAttachmentContact
                  {...{ setCurrentView, goBack, appData: props }}
                />
              )}

              {currentView === 'help_support' && (
                <HelpAttachmentSupportForm
                  {...{ setCurrentView, goBack, appData: props }}
                />
              )}

              {currentView === 'guides' && (
                <HelpAttachmentGuides
                  {...{ setCurrentView, goBack, appData: props }}
                />
              )}

              {currentView.includes('guides/') && (
                <HelpAttachmentGuidesView
                  {...{
                    setCurrentView,
                    goBack,
                    slug: currentView.split('/')[1],
                    appData: props,
                  }}
                />
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.a
        onClick={() => setShown(!shown)}
        initial="hidden"
        animate="visible"
        variants={animateButton}
        className="fixed bottom-6 right-6 bg-blue-600 shadow-sm w-14 h-14 rounded-full flex items-center justify-center text-white hover:text-gray-300 cursor-pointer hover:bg-blue-700 transition ease-in-out duration-150 z-50"
      >
        {shown ? (
          <AiOutlineClose size={30} />
        ) : (
          <HelperIcon className="block h-8 w-8" />
        )}
      </motion.a>
    </>
  );
};

export default HelpAttachment;
